<template>
  <Card>
    <span slot="title">拍单数据统计报表</span>
    <el-button slot="btn" icon="el-icon-refresh" @click="$refresh(getTakeOrdersStatistics)">刷新</el-button>
    <div slot="content" class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="医馆名称">
            <el-select v-model="searchForm.deptIds" multiple placeholder="请选择医馆名称">
              <el-option v-for="item in deptOptions" :key="item.value"  :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="月份">
            <el-date-picker v-model="searchForm.date" value-format="yyyy-MM" type="monthrange" align="right"
            unlink-panels range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"
            :picker-options="pickerOptions" @change="val => $setDates(val, getTakeOrdersStatistics)"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getTakeOrdersStatistics, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getTakeOrdersStatistics, { deptIds: [], dates: [], date: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button @click="$exportSummary(searchForm, '/report/export/auction', '拍单数据统计')"
          icon="el-icon-download" type="primary">导出报表</el-button>
      </div>
      <!-- 拍单数据列表 -->
      <el-table v-loading="loading" :data="takeOrdersList" :max-height="tableHeight" border>
        <el-table-column label="订单编号" prop="orderNumber" min-width="140" fixed/>
        <el-table-column label="订单状态" prop="status"/>
        <el-table-column label="医生姓名" prop="doctorName"/>
        <el-table-column label="医生类型" prop="doctorType"/>
        <el-table-column label="患者名称" prop="patientName"/>
        <el-table-column label="收件人" prop="consigneeName"/>
        <el-table-column label="收件电话" prop="phone"/>
        <el-table-column label="收货地址" prop="addr"/>
        <el-table-column label="支付方式" prop="payWay"/>
        <el-table-column label="处方付数(付)" prop="doseNumber" min-width="110"/>
        <el-table-column label="处方类型" prop="doseType"/>
        <el-table-column label="是否加工" prop="isProcessing"/>
        <el-table-column label="加工类型" prop="processingWay"/>
        <el-table-column label="辅料添加" prop="ingredient"/>
        <el-table-column label="熬药袋数(袋)" prop="bagNumber" min-width="110"/>
        <el-table-column label="药材费(元)" prop="drugPrice" min-width="90"/>
        <el-table-column label="熬药费(元)" prop="processingPrice" min-width="90"/>
        <el-table-column label="配送费(元)" prop="deliveryPrice" min-width="90"/>
        <el-table-column label="总价(元)" prop="realPay" min-width="80"/>
        <el-table-column label="快递公司" prop="companyName" min-width="80"/>
        <el-table-column label="快递单号" prop="deliveryNumber" min-width="80"/>
        <el-table-column label="所属分馆" prop="deptName" min-width="80"/>
        <el-table-column label="拍单时间" prop="auctionTime" min-width="80"/>
        <el-table-column label="推送订单金额时间" prop="paymentTime" min-width="80"/>
        <el-table-column label="订单生成成功时间" prop="generateTime" min-width="80"/>
        <el-table-column label="审方时间" prop="auditTime" min-width="80"/>
        <el-table-column label="配方时间" prop="recipeTime" min-width="80"/>
        <el-table-column label="复审时间" prop="recheckTime" min-width="80"/>
        <el-table-column label="加工时间" prop="processingTime" min-width="80"/>
        <el-table-column label="打包时间" prop="packagingTime" min-width="80"/>
        <el-table-column label="发货时间" prop="deliveryTime" min-width="80"/>
        <el-table-column label="客户备注" prop="patientRemark" min-width="80"/>
        <el-table-column label="馆内备注" prop="operration" min-width="120"/>
      </el-table>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getTakeOrdersStatistics)"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total"/>
    </div>
  </Card>
</template>

<script lang="js">
import { takeOrdersStatistics } from "@/api/statement"; // 报表统计请求
export default {
  name: 'TakeOrdersStatistics',
  data() {
    return {
      loading: false, // 加载中
      searchForm: { deptIds: [], dates: [], date: null }, // 查询表单
      takeOrdersList: [], // 拍单数据统计列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      deptOptions: this.$session.get('options'), // 医馆列表
      pickerOptions:{ // 排班日期可选范围
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: this.$shortcuts
      },
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.$forceUpdate();
    this.$setCurMonth(this.getTakeOrdersStatistics);
  },
  methods: {
    // 请求所有拍单数据统计列表
    async getTakeOrdersStatistics() {
      let { rows, code, total } = await takeOrdersStatistics(this.currentPage, this.pageSize, this.searchForm);
      if (code == 200) {
        this.takeOrdersList = rows;
        this.total = total;
      }
      this.loading = false;
    }
  },
};
</script>